@if (showSidePanels()) {
  <mat-toolbar class="side-elements" color="primary">
    <mat-toolbar-row class="mat-elevation-z6" style="height:5px;" />
    <mat-toolbar-row class="mat-elevation-z6">
      <button mat-icon-button routerLinkActive="active" [routerLink]="['/home']">
        <mat-icon matListItemIcon>dashboard</mat-icon>
      </button>
      <span>GAMS</span>
      <div class="current-version">v3.2</div>
      @if (showMaintenanceWarning()) {
        <div style="font-size: small; margin-left: 15px;" [innerHTML]="getMaintenanceWarning()"></div>
      }
      <span class="example-spacer"></span>
      <div class="toolbar-roles">
        @for (role of roles; track role) {
          <div class="toolbar-role">
            @if (getSelectedUserRoleId() == role.id) {
              <div>
                <button class="role-btn" mat-raised-button disableRipple>
                  <mat-icon>{{role.is_supplier ? 'business' : 'location_city'}}</mat-icon>{{role.factory}}
                </button>
              </div>
            }
            @if (getSelectedUserRoleId() != role.id) {
              <div class="toolbar-role">
                <button class="role-btn" mat-raised-button color="primary" (click)="setUserRole(role.id)">
                  <mat-icon>{{role.is_supplier ? 'business' : 'location_city'}}</mat-icon>{{role.factory}}
                </button>
              </div>
            }
          </div>
        }
      </div>
      <button mat-icon-button [matMenuTriggerFor]="helpMenu">
        <mat-icon>help_outline</mat-icon>
      </button>
      <mat-menu #helpMenu="matMenu">
        <a mat-menu-item target="_blank" href="/downloads/User Manual.pdf" title="User Manual.pdf">
          <mat-icon>book</mat-icon>User Manual
        </a>
        <a mat-menu-item target="_blank" href="/downloads/Leather and PU coated fabric claim routine.pdf"
          title="Leather and PU coated fabric claim routine.pdf">
          <mat-icon>description</mat-icon>Leather and PU coated fabric claim routine
        </a>
        <button mat-menu-item routerLinkActive="active" [routerLink]="['/faq']">
          <mat-icon>contact_support</mat-icon>FAQ
        </button>
        <button mat-menu-item routerLinkActive="active" [routerLink]="['/help']">
          <mat-icon>get_app</mat-icon>Upload templates
        </button>
        <button mat-menu-item routerLinkActive="active" [routerLink]="['/releasenotes']">
          <mat-icon>new_releases</mat-icon>Release notes
        </button>
      </mat-menu>
      <button mat-icon-button [matMenuTriggerFor]="userMenu">
        <mat-icon>person_outline</mat-icon>
      </button>
      <mat-menu #userMenu="matMenu">
        <button mat-menu-item (click)="changePassword()">
          <mat-icon>settings</mat-icon>Change password
        </button>
        <button mat-menu-item (click)="logout()">
          <mat-icon>exit_to_app</mat-icon>Log out
        </button>
      </mat-menu>
      <span class="logged-in-user">{{this.login}}</span>
    </mat-toolbar-row>
    <mat-toolbar-row class="mat-elevation-z6" style="height:5px;" />
  </mat-toolbar>
}

<mat-drawer-container class="example-container" id="example_container"
  [style.height]="(showSidePanels() ? 'calc(100% - 74px)' : '100%')" autosize>
  @if (showSidePanels()) {
    <mat-drawer #drawer class="example-sidenav mat-elevation-z8 side-elements" mode="side" opened
      >
      <mat-action-list>
        <button mat-list-item (click)="changeLeftPanel()">
          @if (showLeftCaptions) {
            <mat-icon matListItemIcon>chevron_left</mat-icon>
          }
          @if (!showLeftCaptions) {
            <mat-icon matListItemIcon>chevron_right</mat-icon>
          }
        </button>
        <button mat-list-item routerLinkActive="active" [routerLink]="['/home']">
          <mat-icon matListItemIcon>home</mat-icon>
          @if (showLeftCaptions) {
            <p class="menu-button">Home</p>
          }
        </button>
        <button mat-list-item routerLinkActive="active" [routerLink]="['/orders']">
          <mat-icon matListItemIcon svgIcon="orders" aria-hidden="false" aria-label="orders" />
          @if (showLeftCaptions) {
            <p class="menu-button">Orders</p>
          }
        </button>
        <button mat-list-item routerLinkActive="active" [routerLink]="['/claims']">
          <mat-icon matListItemIcon svgIcon="claims" aria-hidden="false" aria-label="claims" />
          @if (showLeftCaptions) {
            <p class="menu-button">Claims</p>
          }
        </button>
        @if (haveAccessToModule('forecasts')) {
          <button mat-list-item routerLinkActive="active" [routerLink]="['/forecasts']"
            >
            <mat-icon matListItemIcon svgIcon="forecast" />
            @if (showLeftCaptions) {
              <p class="menu-button">Forecasts</p>
            }
          </button>
        }
        @if (showLeftCaptions) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <button mat-list-item routerLinkActive="active">
                  <mat-icon matListItemIcon>settings</mat-icon>
                  <p class="menu-button">Configuration</p>
                </button>
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (haveAccessToModule('users')) {
              <button mat-list-item routerLinkActive="active" [routerLink]="['/users']">
                <p class="menu-button">Users</p>
              </button>
            }
            <button mat-list-item routerLinkActive="active" [routerLink]="['/products']">
              <p class="menu-button">Products</p>
            </button>
            <button mat-list-item routerLinkActive="active" [routerLink]="['/factories']">
              <p class="menu-button">Factories</p>
            </button>
            @if (haveAccessToModule('parameters')) {
              <button mat-list-item routerLinkActive="active" [routerLink]="['/parameters']"
                >
                <p class="menu-button">Parameters Setting</p>
              </button>
            }
            @if (haveAccessToModule('agreements')) {
              <button mat-list-item routerLinkActive="active" [routerLink]="['/agreements']"
                >
                <p class="menu-button">General Agreement</p>
              </button>
            }
            @if (haveAccessToModule('matrix')) {
              <button mat-list-item routerLinkActive="active" [routerLink]="['/matrix']">
                <p class="menu-button">Matrix</p>
              </button>
            }
          </mat-expansion-panel>
        }
        @if (!showLeftCaptions) {
          <button mat-list-item routerLinkActive="active" [routerLink]="['/configmodules']">
            <mat-icon matListItemIcon>settings</mat-icon>
          </button>
        }
        @if (haveAccessToModule('kpi')) {
          <button mat-list-item routerLinkActive="active" [routerLink]="['/kpireports']">
            <mat-icon matListItemIcon>insert_chart_outlined</mat-icon>
            @if (showLeftCaptions) {
              <p class="menu-button">KPI Reports</p>
            }
          </button>
        }
        @if (haveAccessToModule('calendar')) {
          <button mat-list-item routerLinkActive="active" [routerLink]="['/calendar']"
            >
            <!-- <button mat-list-item> -->
            <mat-icon matListItemIcon>today</mat-icon>
            @if (showLeftCaptions) {
              <p class="menu-button">Calendar</p>
            }
          </button>
        }
        @if (haveAccessToModule('communication')) {
          <button mat-list-item routerLinkActive="active" [routerLink]="['/communication']"
            >
            <mat-icon matListItemIcon>mail</mat-icon>
            @if (showLeftCaptions) {
              <p class="menu-button">Communication</p>
            }
          </button>
        }
      </mat-action-list>
      <div class="db">{{this.db}}</div>
    </mat-drawer>
  }

  @if (showSidePanels() && (haveAccessToModule('early_warnings') || filtersRightPanel.length>0)) {
    <mat-drawer class="example-sidenav mat-elevation-z8 side-elements" mode="side" opened position="end"
      >
      <mat-action-list>
        <button mat-list-item (click)="changeRightPanel()">
          @if (showRightCaptions) {
            <mat-icon matListItemIcon>chevron_right</mat-icon>
          }
          @if (!showRightCaptions) {
            <mat-icon matListItemIcon>chevron_left</mat-icon>
          }
        </button>
        @if (haveAccessToModule('early_warnings')) {
          <button mat-list-item routerLinkActive="active" [routerLink]="['/warnings']"
            >
            <mat-icon matListItemIcon matBadge="{{earlyWarningsCount}}" matBadgeColor="{{earlyWarningsCount == 0 ? 'primary' : 'accent'}}" aria-hidden="false">
            warning</mat-icon>
            @if (showRightCaptions) {
              <p class="menu-button">Early Warnings</p>
            }
          </button>
        }
        @for (filter of filtersRightPanel; track filter) {
          <button mat-list-item routerLinkActive="active"
            [routerLink]="['/' + filter.module + '/filter', filter?.id]" (contextmenu)="filterClick($event, filter.id)">
            <mat-icon matListItemIcon svgIcon="{{filter.module}}" aria-hidden="false" id="filterIcon_{{filter?.id}}"
              matBadge="{{filter?.number ? filter.number : 0}}" title="{{filter?.search_name + ': ' + filter?.number}}" matBadgeColor="primary"
              [ngStyle]="styleBadge(filter?.id, filter?.color)" />
            @if (showRightCaptions) {
              <p class="menu-button" title="{{filter?.search_name + ': ' + filter?.number}}">
              {{filter?.search_name.toString().substring(0,15) + (filter.search_name.length>15 ? '...' : '')}}</p>
            }
          </button>
        }
      </mat-action-list>
    </mat-drawer>
  }

  <div class="example-sidenav-content">

    <router-outlet />

  </div>

  <div class="notranslate" id='config_data_tmp' hidden></div>
</mat-drawer-container>
